import { storage } from "../storage/storage";
import { IdeaflowUser } from "./useAuth";

// ts-prune-ignore-next
export type Auth = AuthLoggedIn | AuthLoggedOut;

// ts-prune-ignore-next
export type AuthLoggedIn = {
  type: "logged-in";
  accessToken: string;
  user: IdeaflowUser;
};

// ts-prune-ignore-next
export type AuthLoggedOut = {
  type: "logged-out";
};

const authKey = "auth-state";

export async function getAuth(): Promise<Auth | null> {
  return await storage.getItem(authKey);
}

// ts-prune-ignore-next
export async function setAuth(auth: Auth) {
  await storage.setItem(authKey, auth);
}

// ts-prune-ignore-next
export async function clearAuth() {
  await storage.removeItem(authKey);
}
